import React from 'react'
import ProgressBar from "react-scroll-progress-bar";

function Progressbar() {
    return (
        <div>
            <ProgressBar />
        </div>
    )
}

export default Progressbar
